/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import jobStyles from "./jobStyles";
import TextContainer from "../../Container/TextContainer";
import { Link, Paper } from "@mui/material";

type SendApplicationProps = {
  to?: string;
};

const SendApplication = ({ to }: SendApplicationProps) => {
  return (
    <TextContainer sx={jobStyles.container}>
      <Paper sx={jobStyles.sendApplicationBox}>
        Sende Deine Bewerbungsunterlagen inkl. Angabe des Startdatums und Jahreszielgehalts an
        <br />
        {to && (
          <>
            {to}
            <br />
          </>
        )}
        <Link
          href={"mailto:jobs@legalbird.de"}
          sx={(theme) => ({
            textDecorationColor: theme.palette.primary.main,
          })}
        >
          jobs@legalbird.de
        </Link>
      </Paper>
      <br />
      <br />
    </TextContainer>
  );
};

export default SendApplication;
